<script>
import FTooltip from "../../vfigma/component/feedback/FTooltip.vue";
export default {
  translate25Context: 'vform17',
  components: { FTooltip },
  methods: {
    onToggle: function () {
      if (this.component.confirmMessage) {
        this.confirmShow = true;
        return;
      }
      this.handler.action(this.component, "toggle", []);
    },
    onConfirm: function () {
      this.confirmShow = false;
      this.handler.action(this.component, "toggle", []);
    },
  },
  props: ["component", "handler"],
  data: function () {
    return { confirmShow: false };
  },
};
</script>
  
<template>
  <div>
    <f-tooltip :text="$vt(component.tooltip)" position="bottom">
      <f-toggle :enabled="component.enabled" @toggle="onToggle">
        {{ $vt(component.label) }}
      </f-toggle>
    </f-tooltip>
    <f-modal-base
      v-if="confirmShow"
      :title2="$vt(component.label)"
      closable
      @close="confirmShow = false"
      class="vform17-toggle-confirm-modal"
    >
      <template #content>
        <p>{{ $vt(component.confirmMessage) }}</p>
      </template>
      <template #actions>
        <f-button type="tertiary" @click="confirmShow = false">{{
          $vt("Cancel")
        }}</f-button>
        <f-button type="primary" @click="onConfirm">{{
          $vt("Confirm")
        }}</f-button>
      </template>
    </f-modal-base>
  </div>
</template>

<style lang="scss">
</style>